import request from "utils/request";

export async function createCampaign(payload) {
	return request("/action/create/xcampaign", {
		method: "PUT",
		body: payload
	});
}

export async function saveWizard(payload) {
	return request("/rest/xwizards", {
		method: "POST",
		body: payload
	});
}

export async function addWizard(payload) {
	return request("/rest/xwizards", {
		method: "PUT",
		body: payload
	});
}

export async function getWizard(id) {
	return request("/rest/xwizards/" + id);
}